import { put, take, fork, all } from "redux-saga/effects";
import { ContactServiceScope, ContactServiceAction } from "./types";
import {
  enableScopeLoading,
  disableScopeLoading,
} from "../scope-loading/actions";
import * as Api from "../../service/api";
import { ScopeErrorAction } from "../scope-error/types";
// import RouteNames from "../../routes/type";
// import { navigateTo } from "../../helper";
import {
  // clearCookie,
  getFolderName,
  // makeHTMLContentForTicket,
} from "./helpers";
import { updateCSState } from "./actions"; //cleanUpstate,
// import { RootState } from "../root-reducer";
import axios from "axios";

// function* createDeskContactService() {
//   while (true) {
//     yield take(ContactServiceAction.CREATE_DESK_TICKET);
//     yield put(enableScopeLoading(ContactServiceScope));
//     try {
//       const stateData = yield select(
//         (state: RootState) => state.contactService
//       );
//       const data = yield call(Api.deskTicket.contactServiceTicket, {
//         subject: `Ace 2.0 Consumer Portal Support Request - ${stateData.customerDetails.name}`,
//         contact_email: stateData.customerDetails.email,
//         description: makeHTMLContentForTicket(stateData),
//       });
//       if (data?.id) {
//         clearCookie("data");
//         clearCookie("foldername");
//         yield put(cleanUpstate());
//         yield navigateTo(
//           `/${RouteNames.CONTACT_SERVICE}?step=5&ticket=${data?.ticketNumber}&id=${data?.ticketNumber}`
//         );
//       }
//     } catch (error) {
//       console.log("error:", error);
//       yield put({
//         type: ScopeErrorAction.SET_SCOPE_ERROR,
//         payload: ContactServiceScope,
//         error,
//       });
//     } finally {
//       yield put(disableScopeLoading(ContactServiceScope));
//     }
//   }
// }

// function* uploadImageFlow() {
//   while (true) {
//     const { payload } = yield take(ContactServiceAction.UPLOAD_IMAGE);
//     const { fieldName, files } = payload;
//     yield put(enableScopeLoading(ContactServiceScope));
//     try {
//       const folderName = getFolderName();
//       const uploadedFileUrls = yield all(
//         files.map(function* (file) {
//           const url = yield Api.deskTicket.getPreSignedUrl(
//             folderName,
//             file.type
//           );
//           yield axios.put(url, file, {
//             headers: {
//               "Content-Type": file.type,
//             },
//           });
//           const data = new URL(url);
//           data.search = "";
//           return data.toString();
//         })
//       );
//       yield put(
//         updateCSState({ documents: { [fieldName]: uploadedFileUrls } })
//       );
//     } catch (error) {
//       yield put({
//         type: ScopeErrorAction.SET_SCOPE_ERROR,
//         payload: ContactServiceScope,
//         error,
//       });
//     } finally {
//       yield put(disableScopeLoading(ContactServiceScope));
//     }
//   }
// }

export default function* contactServiceSaga() {
  // yield fork(createDeskContactService);
  // yield fork(uploadImageFlow);
}
